var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9187 19.9238H16.5875V14.7025C16.5875 13.4575 16.5625 11.855 14.85 11.855C13.1137 11.855 12.8488 13.21 12.8488 14.6112V19.9238H9.51625V9.1875H12.7162V10.65H12.76C13.2075 9.8075 14.295 8.91625 15.92 8.91625C19.295 8.91625 19.92 11.1387 19.92 14.03V19.9238H19.9187ZM5.75375 7.71875C5.49944 7.71908 5.24757 7.66921 5.01258 7.57201C4.77758 7.4748 4.56408 7.33217 4.38432 7.15229C4.20456 6.97241 4.06207 6.75882 3.96501 6.52377C3.86796 6.28871 3.81826 6.03681 3.81875 5.7825C3.819 5.39979 3.93272 5.02575 4.14555 4.70768C4.35838 4.38961 4.66074 4.14179 5.01441 3.99557C5.36808 3.84934 5.75717 3.81127 6.13248 3.88618C6.50778 3.96108 6.85244 4.14559 7.12288 4.41638C7.39332 4.68717 7.57739 5.03208 7.65181 5.40748C7.72623 5.78288 7.68766 6.17192 7.54098 6.5254C7.39429 6.87888 7.14608 7.18092 6.82774 7.39334C6.50939 7.60575 6.13521 7.719 5.7525 7.71875H5.75375ZM7.42375 19.9238H4.0825V9.1875H7.425V19.9238H7.42375ZM21.5875 0.75H2.41125C1.49125 0.75 0.75 1.475 0.75 2.37125V21.6287C0.75 22.525 1.4925 23.25 2.41 23.25H21.5825C22.5 23.25 23.25 22.525 23.25 21.6287V2.37125C23.25 1.475 22.5 0.75 21.5825 0.75H21.5863H21.5875Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinimg);
export default __webpack_public_path__ + "static/media/linkedinimg.c0c70bb2cd790bc44efeceaa138dfec0.svg";
export { ForwardRef as ReactComponent };